import { FeatureDefinition } from '../entities';

export const requireEmailConsentFeature = 'require_email_consent_appnebula';

export const requireEmailConsentFeatureConfig: FeatureDefinition = {
  defaultValue: true,
};
